import { curry, unfold } from 'ramda';

export const rangeStep = curry((start: number, end: number, step: number) =>
  unfold(
    seed => ((step > 0 && seed < end) || (step < 0 && seed > end) ? [seed, seed + step] : false),
    start
  )
);
